import { fetchAPI } from "../../redux/api";

const read = async responsePromise => {
  const response = await responsePromise;
  if (response.ok) return response.status === 204 ? null : response.json();
  let message = "General settings request failed.";
  try { const body = await response.json(); message = body.detail || body.message || body.title || message; } catch (_) {}
  throw new Error(message);
};

export const getGeneralSettings = () => read(fetchAPI("general-settings"));
export const saveGeneralSettings = settings => read(fetchAPI("general-settings", {
  requirePaymentMethod: Boolean(settings.requirePaymentMethod),
  reservationDepositRequired: Boolean(settings.reservationDepositRequired),
  reservationDepositType: settings.reservationDepositType === "Percentage" ? "Percentage" : "Fixed",
  reservationDepositValue: Number(settings.reservationDepositValue) || 0,
  reservationReminderEnabled: Boolean(settings.reservationReminderEnabled),
  reservationReminderHours: Number(settings.reservationReminderHours) || 24,
  reservationReminderChannel: settings.reservationReminderChannel === "WhatsApp" ? "WhatsApp" : "SMS",
  reservationNoShowAutomationEnabled: Boolean(settings.reservationNoShowAutomationEnabled),
  reservationNoShowGraceMinutes: Number(settings.reservationNoShowGraceMinutes) || 30,
}, "PUT"));
